import React, { PureComponent } from 'react';
import { AntdIconProps } from '@ant-design/icons/lib/components/AntdIcon';

export class NotAllowedIcon extends PureComponent<
    Pick<
        AntdIconProps,
        | 'max'
        | 'required'
        | 'high'
        | 'low'
        | 'disabled'
        | 'default'
        | 'start'
        | 'open'
        | 'media'
        | 'hidden'
        | 'cite'
        | 'data'
        | 'dir'
        | 'form'
        | 'label'
        | 'slot'
        | 'span'
        | 'style'
        | 'summary'
        | 'title'
        | 'pattern'
        | 'async'
        | 'defer'
        | 'manifest'
        | 'color'
        | 'content'
        | 'size'
        | 'wrap'
        | 'multiple'
        | 'key'
        | 'children'
        | 'list'
        | 'step'
        | 'aria-label'
        | 'spin'
        | 'rotate'
        | 'accept'
        | 'acceptCharset'
        | 'action'
        | 'allowFullScreen'
        | 'allowTransparency'
        | 'alt'
        | 'as'
        | 'autoComplete'
        | 'autoFocus'
        | 'autoPlay'
        | 'capture'
        | 'cellPadding'
        | 'cellSpacing'
        | 'charSet'
        | 'challenge'
        | 'checked'
        | 'classID'
        | 'cols'
        | 'colSpan'
        | 'controls'
        | 'coords'
        | 'crossOrigin'
        | 'dateTime'
        | 'download'
        | 'encType'
        | 'formAction'
        | 'formEncType'
        | 'formMethod'
        | 'formNoValidate'
        | 'formTarget'
        | 'frameBorder'
        | 'headers'
        | 'height'
        | 'href'
        | 'hrefLang'
        | 'htmlFor'
        | 'httpEquiv'
        | 'integrity'
        | 'keyParams'
        | 'keyType'
        | 'kind'
        | 'loop'
        | 'marginHeight'
        | 'marginWidth'
        | 'maxLength'
        | 'mediaGroup'
        | 'method'
        | 'min'
        | 'minLength'
        | 'muted'
        | 'name'
        | 'nonce'
        | 'noValidate'
        | 'optimum'
        | 'placeholder'
        | 'playsInline'
        | 'poster'
        | 'preload'
        | 'readOnly'
        | 'rel'
        | 'reversed'
        | 'rows'
        | 'rowSpan'
        | 'sandbox'
        | 'scope'
        | 'scoped'
        | 'scrolling'
        | 'seamless'
        | 'selected'
        | 'shape'
        | 'sizes'
        | 'src'
        | 'srcDoc'
        | 'srcLang'
        | 'srcSet'
        | 'target'
        | 'type'
        | 'useMap'
        | 'value'
        | 'width'
        | 'wmode'
        | 'defaultChecked'
        | 'defaultValue'
        | 'suppressContentEditableWarning'
        | 'suppressHydrationWarning'
        | 'accessKey'
        | 'className'
        | 'contentEditable'
        | 'contextMenu'
        | 'draggable'
        | 'id'
        | 'lang'
        | 'spellCheck'
        | 'tabIndex'
        | 'translate'
        | 'radioGroup'
        | 'role'
        | 'about'
        | 'datatype'
        | 'inlist'
        | 'prefix'
        | 'property'
        | 'resource'
        | 'typeof'
        | 'vocab'
        | 'autoCapitalize'
        | 'autoCorrect'
        | 'autoSave'
        | 'itemProp'
        | 'itemScope'
        | 'itemType'
        | 'itemID'
        | 'itemRef'
        | 'results'
        | 'security'
        | 'unselectable'
        | 'inputMode'
        | 'is'
        | 'aria-activedescendant'
        | 'aria-atomic'
        | 'aria-autocomplete'
        | 'aria-busy'
        | 'aria-checked'
        | 'aria-colcount'
        | 'aria-colindex'
        | 'aria-colspan'
        | 'aria-controls'
        | 'aria-current'
        | 'aria-describedby'
        | 'aria-details'
        | 'aria-disabled'
        | 'aria-dropeffect'
        | 'aria-errormessage'
        | 'aria-expanded'
        | 'aria-flowto'
        | 'aria-grabbed'
        | 'aria-haspopup'
        | 'aria-hidden'
        | 'aria-invalid'
        | 'aria-keyshortcuts'
        | 'aria-labelledby'
        | 'aria-level'
        | 'aria-live'
        | 'aria-modal'
        | 'aria-multiline'
        | 'aria-multiselectable'
        | 'aria-orientation'
        | 'aria-owns'
        | 'aria-placeholder'
        | 'aria-posinset'
        | 'aria-pressed'
        | 'aria-readonly'
        | 'aria-relevant'
        | 'aria-required'
        | 'aria-roledescription'
        | 'aria-rowcount'
        | 'aria-rowindex'
        | 'aria-rowspan'
        | 'aria-selected'
        | 'aria-setsize'
        | 'aria-sort'
        | 'aria-valuemax'
        | 'aria-valuemin'
        | 'aria-valuenow'
        | 'aria-valuetext'
        | 'dangerouslySetInnerHTML'
        | 'onCopy'
        | 'onCopyCapture'
        | 'onCut'
        | 'onCutCapture'
        | 'onPaste'
        | 'onPasteCapture'
        | 'onCompositionEnd'
        | 'onCompositionEndCapture'
        | 'onCompositionStart'
        | 'onCompositionStartCapture'
        | 'onCompositionUpdate'
        | 'onCompositionUpdateCapture'
        | 'onFocus'
        | 'onFocusCapture'
        | 'onBlur'
        | 'onBlurCapture'
        | 'onChange'
        | 'onChangeCapture'
        | 'onBeforeInput'
        | 'onBeforeInputCapture'
        | 'onInput'
        | 'onInputCapture'
        | 'onReset'
        | 'onResetCapture'
        | 'onSubmit'
        | 'onSubmitCapture'
        | 'onInvalid'
        | 'onInvalidCapture'
        | 'onLoad'
        | 'onLoadCapture'
        | 'onError'
        | 'onErrorCapture'
        | 'onKeyDown'
        | 'onKeyDownCapture'
        | 'onKeyPress'
        | 'onKeyPressCapture'
        | 'onKeyUp'
        | 'onKeyUpCapture'
        | 'onAbort'
        | 'onAbortCapture'
        | 'onCanPlay'
        | 'onCanPlayCapture'
        | 'onCanPlayThrough'
        | 'onCanPlayThroughCapture'
        | 'onDurationChange'
        | 'onDurationChangeCapture'
        | 'onEmptied'
        | 'onEmptiedCapture'
        | 'onEncrypted'
        | 'onEncryptedCapture'
        | 'onEnded'
        | 'onEndedCapture'
        | 'onLoadedData'
        | 'onLoadedDataCapture'
        | 'onLoadedMetadata'
        | 'onLoadedMetadataCapture'
        | 'onLoadStart'
        | 'onLoadStartCapture'
        | 'onPause'
        | 'onPauseCapture'
        | 'onPlay'
        | 'onPlayCapture'
        | 'onPlaying'
        | 'onPlayingCapture'
        | 'onProgress'
        | 'onProgressCapture'
        | 'onRateChange'
        | 'onRateChangeCapture'
        | 'onSeeked'
        | 'onSeekedCapture'
        | 'onSeeking'
        | 'onSeekingCapture'
        | 'onStalled'
        | 'onStalledCapture'
        | 'onSuspend'
        | 'onSuspendCapture'
        | 'onTimeUpdate'
        | 'onTimeUpdateCapture'
        | 'onVolumeChange'
        | 'onVolumeChangeCapture'
        | 'onWaiting'
        | 'onWaitingCapture'
        | 'onAuxClick'
        | 'onAuxClickCapture'
        | 'onClick'
        | 'onClickCapture'
        | 'onContextMenu'
        | 'onContextMenuCapture'
        | 'onDoubleClick'
        | 'onDoubleClickCapture'
        | 'onDrag'
        | 'onDragCapture'
        | 'onDragEnd'
        | 'onDragEndCapture'
        | 'onDragEnter'
        | 'onDragEnterCapture'
        | 'onDragExit'
        | 'onDragExitCapture'
        | 'onDragLeave'
        | 'onDragLeaveCapture'
        | 'onDragOver'
        | 'onDragOverCapture'
        | 'onDragStart'
        | 'onDragStartCapture'
        | 'onDrop'
        | 'onDropCapture'
        | 'onMouseDown'
        | 'onMouseDownCapture'
        | 'onMouseEnter'
        | 'onMouseLeave'
        | 'onMouseMove'
        | 'onMouseMoveCapture'
        | 'onMouseOut'
        | 'onMouseOutCapture'
        | 'onMouseOver'
        | 'onMouseOverCapture'
        | 'onMouseUp'
        | 'onMouseUpCapture'
        | 'onSelect'
        | 'onSelectCapture'
        | 'onTouchCancel'
        | 'onTouchCancelCapture'
        | 'onTouchEnd'
        | 'onTouchEndCapture'
        | 'onTouchMove'
        | 'onTouchMoveCapture'
        | 'onTouchStart'
        | 'onTouchStartCapture'
        | 'onPointerDown'
        | 'onPointerDownCapture'
        | 'onPointerMove'
        | 'onPointerMoveCapture'
        | 'onPointerUp'
        | 'onPointerUpCapture'
        | 'onPointerCancel'
        | 'onPointerCancelCapture'
        | 'onPointerEnter'
        | 'onPointerEnterCapture'
        | 'onPointerLeave'
        | 'onPointerLeaveCapture'
        | 'onPointerOver'
        | 'onPointerOverCapture'
        | 'onPointerOut'
        | 'onPointerOutCapture'
        | 'onGotPointerCapture'
        | 'onGotPointerCaptureCapture'
        | 'onLostPointerCapture'
        | 'onLostPointerCaptureCapture'
        | 'onScroll'
        | 'onScrollCapture'
        | 'onWheel'
        | 'onWheelCapture'
        | 'onAnimationStart'
        | 'onAnimationStartCapture'
        | 'onAnimationEnd'
        | 'onAnimationEndCapture'
        | 'onAnimationIteration'
        | 'onAnimationIterationCapture'
        | 'onTransitionEnd'
        | 'onTransitionEndCapture'
        | 'twoToneColor'
    > &
        React.RefAttributes<HTMLSpanElement>
> {
    render() {
        return (
            <span role="img" aria-label="not-allowed" className="anticon anticon-not-allowed" {...this.props}>
                <svg
                    viewBox="64 64 896 896"
                    focusable="false"
                    data-icon="not-allowed"
                    width="1em"
                    height="1em"
                    fill="currentColor"
                    aria-hidden="true">
                    <path
                        d="M 511.99999,64 C 264.58454,64 64,264.58453 64,512.01492 c 0,247.3856 200.58454,447.98507 447.99999,447.98507 247.41546,0 448.00002,-200.59947 448.00002,-447.98507 C 960.00001,264.58453 759.41545,64 511.99999,64 Z m 328.53333,448.01492 c 0,69.1264 -21.39946,133.23521 -57.88159,186.14401 L 325.82613,241.34827 c 52.92374,-36.48214 117.03254,-57.8816 186.17386,-57.8816 181.44,0 328.53333,147.10826 328.53333,328.54825 z m -657.06666,0 c 0,-69.14133 21.4144,-133.26507 57.8816,-186.18879 l 456.8256,456.8256 c -52.9088,36.48213 -117.03254,57.89653 -186.17387,57.89653 -181.43999,0 -328.53333,-147.1232 -328.53333,-328.53334 z"
                        strokeWidth="1.20414"
                    />
                </svg>
            </span>
        );
    }
}
